<script lang="ts">
    import Switch from "@components/material/Switch.svelte"
    import { ImageQuotePrefs } from "@utils/image-editor/image-quote-prefs"
    import { slide } from "svelte/transition"
    const { paragraphNumbers, sentenceNumbers, boldParagraph } = ImageQuotePrefs
</script>

<div>
    <div class="flex items-center gap-2">
        <Switch id="sentenceNumbers" bind:toggled={$sentenceNumbers} />
        <label for="sentenceNumbers"> Show sentence numbers </label>
    </div>
    <div class="flex items-center gap-2">
        <Switch id="paragraphNumbers" bind:toggled={$paragraphNumbers} />
        <label for="paragraphNumbers"> Show paragraph numbers </label>
    </div>
    {#if $paragraphNumbers}
        <div transition:slide class="flex items-center gap-2">
            <Switch id="boldParagraph" bind:toggled={$boldParagraph} />
            <label for="boldParagraph"> Bold paragraph numbers </label>
        </div>
    {/if}
</div>
